import React, { useEffect, useState } from "react";
import { Table, Button, Form } from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import moment from "moment";
import { formGSTR1Fields, getGridColumnTotal } from "../../utils/client/misc";

const FormGSTR1Table = ({
  data = [],
  onEdit = () => {},
  // onDelete,
  activePage,
  limit,
  setEmpIds = () => {},
  selectedMonth,
  isDataSendToCA,
  empIds = [],
}) => {
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  let totalTaxableValue = 0;
  let totalIntegratedTax = 0;
  let totalCentralTax = 0;
  let totalStateTax = 0;
  let totalInvoiceValue = 0;
  let totalCess = 0;

  totalTaxableValue = getGridColumnTotal(data, activePage, limit, "tv");
  totalIntegratedTax = getGridColumnTotal(data, activePage, limit, "ig");
  totalCentralTax = getGridColumnTotal(data, activePage, limit, "cg");
  totalStateTax = getGridColumnTotal(data, activePage, limit, "sg");
  totalInvoiceValue = getGridColumnTotal(data, activePage, limit, "iv");
  totalCess = getGridColumnTotal(data, activePage, limit, "ce");

  useEffect(() => {
    if (selectedMonth) {
      setSelectedIds([]);
      setEmpIds([]);
    }
  }, [selectedMonth]);

  // Select All checkbox
  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);

    if (checked) {
      const allIds = data
        ?.slice((activePage - 1) * limit, activePage * limit)
        .map((row) => row.id);
      setSelectedIds(allIds);
      setEmpIds(allIds);
    } else {
      setSelectedIds([]);
      setEmpIds([]);
    }
  };

  useEffect(() => {
    if (empIds?.length == 0) {
      setSelectAll(false);
    } else {
      setSelectAll(true);
    }
  }, [empIds]);

  const handleCheckboxChange = (e, id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
    setEmpIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  return (
    <Table striped bordered hover className="w-100 custom-table-form24 ">
      <thead className="table-light">
        <tr>
          <th className="sticky-col col-1 sno" style={{ width: "50px" }}>
            SNo
          </th>
          <th className="sticky-col col-1" style={{ width: "50px" }}>
            {/* <FaTrash
              style={{
                color: "#2c3e50",
                fontSize: "0.8rem",
                cursor: "default",
              }}
            /> */}
            <Form.Group>
              <Form.Check
                type="checkbox"
                disabled={isDataSendToCA}
                checked={selectAll}
                onChange={handleSelectAll}
                // tabIndex={info?.tab}
                className="text-primary"
              />
            </Form.Group>
          </th>
          <th
            className="sticky-col col-2"
            style={{ width: "100px", textAlign: "center" }}
          >
            Action
          </th>
          {formGSTR1Fields.map((col) => (
            <th style={{ width: col.width }} className={col.className || ""}>
              {col.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data
          ?.slice((activePage - 1) * limit, activePage * limit)
          .map((info, index) => (
            <tr key={index}>
              <td className="sticky-col col-1 text-center sno">
                {index + 1 + limit * (activePage - 1)}
              </td>
              <td className="sticky-col col-1 text-center">
                {/* <FaTrash
                  style={{
                    color: "#2c3e50",
                    fontSize: "0.80rem",
                    cursor: "pointer",
                  }}
                  onClick={() => onDelete(info?.id)}
                /> */}
                <Form.Group>
                  <Form.Check
                    type="checkbox"
                    disabled={isDataSendToCA}
                    checked={selectedIds.includes(info?.id)}
                    onChange={(e) => handleCheckboxChange(e, info?.id)}
                    // tabIndex={info?.tab}
                    className="text-primary"
                  />
                </Form.Group>
              </td>
              <td className="sticky-col col-2 text-center">
                <Button variant="link" onClick={() => onEdit(info)}>
                  <FaEdit
                    style={{
                      cursor: "pointer",
                      color: "#2c3e50",
                    }}
                  />
                </Button>
              </td>

              {formGSTR1Fields.map((col) => (
                <td key={col.key} className={col.className || ""}>
                  {col.key === "indt"
                    ? info?.indt && moment(info.indt).format("DD-MM-YYYY")
                    : info?.[col.key] ?? ""}
                </td>
              ))}
            </tr>
          ))}
        {
          data.map((info, index) => (
            <tr key={index}>
              <td className="sticky-col col-1 text-center"></td>
              <td className="sticky-col col-1 text-center"></td>
              <td className="sticky-col col-2 text-center"></td>
              {formGSTR1Fields.map((col) => (
                <td
                  key={col.key}
                  style={{ fontWeight: "bold" }}
                  className={col.className || ""}
                >
                  {col.key === "sug"
                    ? "TOTAL"
                    : col.key === "tn"
                    ? ""
                    : col.key === "inv"
                    ? ""
                    : col.key === "indt"
                    ? ""
                    : col.key === "ra"
                    ? ""
                    : col.key === "tv"
                    ? totalTaxableValue
                    : col.key === "ig"
                    ? totalIntegratedTax
                    : col.key === "cg"
                    ? totalCentralTax
                    : col.key === "sg"
                    ? totalStateTax
                    : col.key === "iv"
                    ? totalInvoiceValue
                    : col.key === "ce"
                    ? totalCess
                    : ""}
                </td>
              ))}
            </tr>
          ))[0]
        }
      </tbody>
    </Table>
  );
};

export default FormGSTR1Table;
